export default __webpack_public_path__ + "static/media/ts-2-4.a576f296.svg";